export const DISABLE_QUOTE_ON_DOUBLE_CLICK_ATTR_NAME = 'data-disable-quote-on-double-click';

export const disableQuoteAttrs = {
  [DISABLE_QUOTE_ON_DOUBLE_CLICK_ATTR_NAME]: true,
};

export const HIGHLIGHT_HOLD_ANIMATION_DURATION = 3000;
export const HIGHLIGHT_IN_AND_OUT_ANIMATION_DURATION = 250;
